/*
data structure like
[
  { time: '2023-01-01', metric1: 10, metric2: 20, otherdimension: 'A' },
  { time: '2023-01-02', metric1: 15, metric2: 25, otherdimension: 'B' },
  ...
]

metrics = [
  { id: 'count'},
   { id: 'clicks' }
]

primaryDimension = { id: 'time', label: 'Time', minimum: '2023-01-01', maximum: '2023-12-31' } | { id: 'otherdimension', label: 'Other Dimension' }

secondaryDimension = { id: 'otherdimension', label: 'Other Dimension' }

*/


export default function prepareChartData({ chartType, data, metrics, primaryDimension, secondaryDimension = null }) {
  // Determine the full range of primary dimension values
  let primaryValues;

  if (primaryDimension.minimum && primaryDimension.maximum) {
    // For continuous dimensions (like dates), generate full range
    primaryValues = generateRange(
      primaryDimension.minimum,
      primaryDimension.maximum,
      primaryDimension.id
    );
  } else {
    // For categorical, just get unique sorted values
    primaryValues = _.sortBy(_.uniq(data.map(d => d[primaryDimension.id])));
  }

  console.log('Primary values:', primaryValues);

  if (!secondaryDimension) {
    return metrics.map(metric => {
      const dataMap = _.keyBy(data, primaryDimension.id);

      const yValues = primaryValues.map(val => dataMap[val]?.[metric.id] ?? null);
      if (metric.cumulative) {
        // If cumulative, calculate cumulative sum
        let sum = 0;
        var y = _.map(yValues, (val) => {
          sum += (val || 0);
          return sum;
        });
      } else {
        var y = yValues;
      }

      return {
        x: primaryValues,
        y,
        name: metric.label || metric.id,
        type: 'bar',
        mode: 'lines+markers'
      };
    });
  }

  const groupedBySecondary = _.groupBy(data, secondaryDimension.id);
  const traces = [];

  _.forEach(groupedBySecondary, (groupData, secondaryValue) => {
    const dataMap = _.keyBy(groupData, primaryDimension.id);

    metrics.forEach(metric => {
      const traceName = metrics.length === 1
        ? secondaryValue
        : `${secondaryValue} - ${metric.label || metric.id}`;

      const yValues = primaryValues.map(val => dataMap[val]?.[metric.id] ?? null);
      if (metric.cumulative) {
        // If cumulative, calculate cumulative sum
        let sum = 0;
        var y = _.map(yValues, (val) => {
          sum += (val || 0);
          return sum;
        });
      } else {
        var y = yValues;
      }

      traces.push({
        x: primaryValues,
        y,
        name: traceName,
        type: 'bar',
        mode: 'lines+markers'
      });
    });
  });

  return traces;
}

// Helper to generate date range (daily increments)
function generateRange(min, max, dimensionId) {
  // For dates
  if (min.match(/^\d{4}-\d{2}-\d{2}/)) {
    const dates = [];
    const start = new Date(min);
    const end = new Date(max);

    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      dates.push(d.toISOString().split('T')[0]);
    }
    return dates;
  }

  // For numbers
  if (typeof min === 'number' && typeof max === 'number') {
    return _.range(min, max + 1);
  }

  // Fallback: can't generate range
  return [min, max];
}
